/* eslint-disable max-lines-per-function */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Keys, locale } from 'src/i18n';
import axios from 'src/workspace/axios';
import { setKeyMetrics, setKeyMetricsMetadata, setStatus } from '../slice';

export const fetchLeadKeyMetricsMetadata = createAsyncThunk(
  'leadKeyMetricsMetadata',
  async ({ cards, params, filters = {} }: any, { dispatch }) => {
    try {
      dispatch(setStatus({ key_metrics_metadata: 'loading' }));
      const { actorId, module } = params;

      const metricApiCalls = cards?.map(async (item) => {
        try {
          const { data: metricData } = await axios.get(
            `/performance/v1/actors/${module}/${actorId}/metrics`,
            {
              params: {
                goal_definition_code: item.goal_definition_code,
                actor_id: actorId,
                actor_type: module,
                filters: JSON.stringify({
                  progress_type: 'all',
                  contribution_type: 'rolled_up',
                  ...filters,
                  frequency: item?.frequency,
                  start_date: item?.date_range?.start,
                }),
              },
            },
          );
          return {
            title: item.title,
            code: item.goal_definition_code,
            card: item,
            data: metricData,
            success: true,
          };
        } catch (error: any) {
          return {
            title: item?.title,
            code: item.goal_definition_code,
            data: null,
            success: false,
            error: error.message,
          };
        }
      });

      const metricResponses: any = await Promise.allSettled(metricApiCalls);

      dispatch(
        setKeyMetricsMetadata(
          metricResponses
            .filter(
              (result) => result.status === 'fulfilled' && result.value.success,
            )
            .map((result) => {
              if (result.status === 'fulfilled') {
                return {
                  title: result.value?.title,
                  code: result.value.code,
                  data: result.value.data,
                  card: result?.value?.card,
                };
              }
              return null;
            })
            .filter(Boolean),
        ),
      );
      dispatch(setStatus({ key_metrics_metadata: 'done' }));
    } catch (e) {
      dispatch(setStatus({ key_metrics_metadata: 'error' }));
    }
  },
);

export const fetchLeadKeyMetrics = createAsyncThunk(
  'leadKeyMetrics',
  async (
    {
      params,
      limit,
      skip,
      filters = {
        frequency: 'all',
        contribution_type: 'rolled_up',
        progress_type: 'all',
      },
    }: { params: any; limit?: any; skip?: any; filters?: any },
    { dispatch },
  ) => {
    try {
      dispatch(setStatus({ key_metrics: 'loading' }));

      const { module, actorId } = params;

      if (!module || !actorId) {
        throw new Error(locale(Keys.MODULE_OR_ACTOR_MISSING));
      }

      const { data } = await axios.get(
        `/performance/v1/actors/${module}/${actorId}/cards`,
        {
          params: {
            filters: JSON.stringify(filters),
            filter_cards: false,
            actor_type: module,
            actor_id: actorId,
            skip,
            limit,
          },
        },
      );
      const {
        cards,
        goal_groups: goalGroups,
        filters: filtersConfig,
      } = data?.body || {};
      dispatch(
        setKeyMetrics({
          cards,
          goal_groups: goalGroups,
          filters: filtersConfig,
        }),
      );

      dispatch(setStatus({ key_metrics: 'done' }));
    } catch (error: any) {
      dispatch(setStatus({ key_metrics: 'error' }));
    }
  },
);

const onActivate = ({ dispatch, props }) => {
  switch (props.cardType) {
    case 'lead_key_metrics':
      dispatch(fetchLeadKeyMetrics({ ...props, limit: 6, skip: 0 }));
      break;
    default:
      break;
  }
};

const onDeactivate = () => {};

export default { onActivate, onDeactivate };
